import React from "react";
import LegalPage, { LegalH2, LegalH3, LegalP, LegalUL } from "../components/LegalPage";
import { useSeo } from "../hooks/useSeo";

export default function Datenschutz() {
  useSeo({
    title: "Datenschutzerklärung – Hype Hafen | DSGVO-konform aus Hamburg",
    description:
      "Datenschutzerklärung der Hype Hafen Social Media Agentur. DSGVO-konforme Datenverarbeitung, keine Tracking-Cookies, transparente Nutzung des Kontaktformulars.",
  });

  return (
    <LegalPage title="Datenschutzerklärung" eyebrow="Datenschutz">
      <LegalP>
        Der Schutz deiner personenbezogenen Daten ist uns ein wichtiges Anliegen. In dieser
        Datenschutzerklärung informieren wir dich darüber, welche Daten wir auf unserer
        Website erheben, wofür wir sie nutzen und welche Rechte dir nach der
        Datenschutz-Grundverordnung (DSGVO) und dem Bundesdatenschutzgesetz (BDSG) zustehen.
      </LegalP>

      <LegalH2>1. Verantwortlicher</LegalH2>
      <LegalP>
        Verantwortlicher im Sinne der DSGVO sowie sonstiger nationaler Datenschutzgesetze
        der Mitgliedstaaten ist:
        <br />
        Hype Hafen
        <br />
        Inhaber: Sardaar Enis-Khan Rafiq
        <br />
        Traute-Lafrenz-Straße 161
        <br />
        22297 Hamburg
        <br />
        Deutschland
        <br />
        E-Mail:{" "}
        <a href="mailto:kontakt@hype-hafen.de" className="text-[#2185D0] underline underline-offset-2">
          kontakt@hype-hafen.de
        </a>
        <br />
        Telefon:{" "}
        <a href="tel:+4915560931517" className="text-[#2185D0] underline underline-offset-2">
          +49 155 60931517
        </a>
      </LegalP>

      <LegalH2>2. Allgemeine Hinweise</LegalH2>
      <LegalP>
        Personenbezogene Daten sind alle Daten, die sich auf eine identifizierte oder
        identifizierbare natürliche Person beziehen (z. B. Name, Anschrift, E-Mail-Adresse,
        IP-Adresse). Die Verarbeitung dieser Daten erfolgt ausschließlich im Einklang mit
        den geltenden gesetzlichen Bestimmungen.
      </LegalP>

      <LegalH2>3. SSL-/TLS-Verschlüsselung</LegalH2>
      <LegalP>
        Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung
        vertraulicher Inhalte eine SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte
        Verbindung erkennst du daran, dass die Adresszeile des Browsers von „http://" auf
        „https://" wechselt und am Schloss-Symbol in deiner Browserzeile.
      </LegalP>

      <LegalH2>4. Hosting</LegalH2>
      <LegalP>
        Unsere Website wird derzeit auf der Infrastruktur der Emergent Agents, Inc.,
        USA, betrieben. Der Anbieter erhebt in sogenannten Logfiles Daten, die dein Browser
        automatisch übermittelt (z. B. IP-Adresse, Datum und Uhrzeit, Browsertyp,
        Betriebssystem, Referrer-URL). Die Erhebung erfolgt zur Sicherstellung eines
        reibungslosen Betriebs sowie zur Verbesserung unseres Angebots.
      </LegalP>
      <LegalP>
        Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einer
        technisch fehlerfreien Darstellung und Sicherheit der Website). Eine Übermittlung
        in die USA erfolgt auf Grundlage von EU-Standardvertragsklauseln (Art. 46 Abs. 2
        lit. c DSGVO).
      </LegalP>

      <LegalH2>5. Erhebung und Verarbeitung personenbezogener Daten</LegalH2>

      <LegalH3>5.1 Server-Logfiles</LegalH3>
      <LegalP>
        Beim Aufruf unserer Website werden automatisch Informationen in Server-Logfiles
        gespeichert, die dein Browser übermittelt. Dies sind:
      </LegalP>
      <LegalUL
        items={[
          "Browsertyp und Browserversion",
          "verwendetes Betriebssystem",
          "Referrer-URL",
          "Hostname des zugreifenden Rechners",
          "Uhrzeit der Serveranfrage",
          "IP-Adresse",
        ]}
      />
      <LegalP>
        Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen.
        Die Daten werden nach Ablauf von maximal 30 Tagen gelöscht, sofern keine
        weitergehende Speicherung zu Beweiszwecken erforderlich ist.
      </LegalP>
      <LegalP>
        Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an
        Stabilität und Sicherheit).
      </LegalP>

      <LegalH3>5.2 Kontaktformular</LegalH3>
      <LegalP>
        Wenn du uns über das Kontaktformular Anfragen zukommen lässt, werden deine Angaben
        (Name, Firma, E-Mail-Adresse, Nachricht) zur Bearbeitung der Anfrage und für den
        Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne
        deine Einwilligung weiter.
      </LegalP>
      <LegalP>
        Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (Anbahnung bzw. Erfüllung eines
        Vertrags) bzw. Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einer
        effektiven Bearbeitung der an uns gerichteten Anfragen). Die Daten werden gelöscht,
        sobald sie für die Erreichung des Zwecks ihrer Erhebung nicht mehr erforderlich
        sind, spätestens jedoch nach Ablauf gesetzlicher Aufbewahrungspflichten
        (i. d. R. 6 bzw. 10 Jahre nach AO und HGB).
      </LegalP>

      <LegalH3>5.3 E-Mail-Versand via Resend</LegalH3>
      <LegalP>
        Für den Versand der Kontaktbenachrichtigungen aus unserem Formular nutzen wir den
        Dienst „Resend" der Resend, Inc., 2261 Market Street #5039, San Francisco, CA
        94114, USA. Beim Abschicken des Formulars werden deine Eingaben verschlüsselt über
        die Server von Resend an unseren Posteingang übermittelt. Resend ist im Rahmen des
        EU-U.S. Data Privacy Framework zertifiziert; ergänzend werden EU-Standardvertrags­
        klauseln eingesetzt. Weitere Informationen findest du in der Datenschutzerklärung
        von Resend:{" "}
        <a
          href="https://resend.com/legal/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#2185D0] underline underline-offset-2"
        >
          resend.com/legal/privacy-policy
        </a>
        .
      </LegalP>
      <LegalP>
        Rechtsgrundlage für die Nutzung von Resend ist Art. 6 Abs. 1 lit. f DSGVO
        (berechtigtes Interesse an einer zuverlässigen Zustellung von Anfragen).
      </LegalP>

      <LegalH3>5.4 Web­fonts (Google Fonts – selbst eingebunden / Web)</LegalH3>
      <LegalP>
        Diese Website nutzt Schriftarten von Google Fonts. Sofern Schriften über die
        Server von Google bezogen werden, baut dein Browser eine Verbindung zu Servern der
        Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irland, auf.
        Hierdurch erlangt Google Kenntnis darüber, dass über deine IP-Adresse unsere
        Website aufgerufen wurde. Die Nutzung erfolgt zur einheitlichen und ansprechenden
        Darstellung unseres Angebots.
      </LegalP>
      <LegalP>
        Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einer
        ansprechenden Darstellung). Weitere Informationen:{" "}
        <a
          href="https://policies.google.com/privacy?hl=de"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#2185D0] underline underline-offset-2"
        >
          policies.google.com/privacy
        </a>
        .
      </LegalP>

      <LegalH3>5.5 Verlinkung zu WhatsApp</LegalH3>
      <LegalP>
        Auf unserer Website befindet sich ein Button, der zu WhatsApp verlinkt. Beim
        Anklicken dieses Buttons wirst du auf eine externe Seite des Anbieters WhatsApp
        Ireland Limited weitergeleitet. Eine Datenübermittlung an WhatsApp erfolgt erst,
        wenn du den Button aktiv anklickst. Wir haben keinen Einfluss auf die Art und den
        Umfang der von WhatsApp verarbeiteten Daten. Bitte beachte die Datenschutz­
        erklärung von WhatsApp:{" "}
        <a
          href="https://www.whatsapp.com/legal/privacy-policy-eea"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#2185D0] underline underline-offset-2"
        >
          whatsapp.com/legal/privacy-policy-eea
        </a>
        .
      </LegalP>
      <LegalP>
        Rechtsgrundlage für die Bereitstellung des Links ist Art. 6 Abs. 1 lit. f DSGVO
        (berechtigtes Interesse an einer schnellen Kontaktaufnahme).
      </LegalP>

      <LegalH2>6. Cookies &amp; Consent-Management</LegalH2>
      <LegalP>
        Diese Website nutzt ein Consent-Banner, das dir beim ersten Besuch automatisch
        angezeigt wird. Erst nach deiner ausdrücklichen Einwilligung werden optionale
        Cookies oder vergleichbare Technologien aktiviert. Deine Auswahl wird lokal in
        deinem Browser (localStorage) revisionssicher mit Zeitstempel gespeichert.
      </LegalP>

      <LegalH3>6.1 Cookie-Kategorien</LegalH3>
      <LegalUL
        items={[
          <>
            <strong>Notwendige Cookies:</strong> Erforderlich für Grundfunktionen der
            Website (z. B. Speicherung deiner Cookie-Präferenz selbst). Diese Cookies sind
            rechtlich zulässig ohne Einwilligung (§ 25 Abs. 2 TDDDG) und lassen sich nicht
            deaktivieren.
          </>,
          <>
            <strong>Statistik &amp; Analyse:</strong> Anonyme Reichweitenmessung, damit
            wir verstehen, welche Inhalte funktionieren. Aktuell nicht aktiv.
          </>,
          <>
            <strong>Marketing:</strong> Messung des Erfolgs einzelner Kampagnen (z. B.
            Instagram-Ads) und ggf. Ausspielen relevanter Werbung. Aktuell nicht aktiv.
          </>,
          <>
            <strong>Externe Medien:</strong> Einbettung von Inhalten Dritter (YouTube,
            Google Maps, Social-Media-Feeds). Diese Anbieter können eigene Cookies setzen.
            Aktuell nicht aktiv.
          </>,
        ]}
      />
      <LegalP>
        Solange keine optionale Kategorie aktiv ist, setzen wir nur technisch erforderliche
        Cookies. Sobald wir Tools wie Google Analytics oder Meta Pixel einbinden, erfolgt
        deren Aktivierung ausschließlich auf Basis deiner Einwilligung nach Art. 6 Abs. 1
        lit. a DSGVO in Verbindung mit § 25 Abs. 1 TDDDG.
      </LegalP>

      <LegalH3>6.2 Einwilligung widerrufen &amp; Auswahl ändern</LegalH3>
      <LegalP>
        Du kannst deine Einwilligung jederzeit für die Zukunft widerrufen oder ändern.
        Nutze dazu den Link <em>„Cookie-Einstellungen"</em> im Footer der Website. Dort
        öffnet sich das Consent-Banner erneut mit deiner aktuellen Auswahl. Nach dem
        Widerruf werden zuvor gesetzte optionale Cookies bei deinem nächsten Besuch nicht
        mehr geladen.
      </LegalP>

      <LegalH2>7. Empfänger personenbezogener Daten</LegalH2>
      <LegalP>
        Eine Weitergabe deiner personenbezogenen Daten an Dritte erfolgt nur, soweit dies
        gesetzlich erlaubt ist, du eingewilligt hast oder dies zur Vertragserfüllung
        erforderlich ist. Auftragsverarbeiter (insbesondere unser Hosting-Anbieter und der
        E-Mail-Versanddienst) handeln ausschließlich auf unsere Weisung und sind durch
        Verträge nach Art. 28 DSGVO verpflichtet, ein angemessenes Schutzniveau zu
        gewährleisten.
      </LegalP>

      <LegalH2>8. Datenübermittlung in Drittländer</LegalH2>
      <LegalP>
        Soweit Daten an Empfänger in Drittländern (insbesondere in die USA) übermittelt
        werden, erfolgt dies entweder auf Grundlage eines Angemessenheitsbeschlusses der
        EU-Kommission (z. B. EU-U.S. Data Privacy Framework, Art. 45 DSGVO) oder auf
        Grundlage von EU-Standardvertragsklauseln (Art. 46 Abs. 2 lit. c DSGVO). Eine
        Kopie dieser Garantien kann unter den oben genannten Kontaktdaten angefordert
        werden.
      </LegalP>

      <LegalH2>9. Speicherdauer</LegalH2>
      <LegalP>
        Wir speichern personenbezogene Daten nur so lange, wie es für die jeweiligen
        Zwecke erforderlich ist oder gesetzliche Aufbewahrungsfristen (insb. nach HGB und
        AO) es vorschreiben. Danach werden die Daten gelöscht oder anonymisiert.
      </LegalP>

      <LegalH2>10. Deine Rechte als betroffene Person</LegalH2>
      <LegalP>Dir stehen folgende Rechte zu:</LegalP>
      <LegalUL
        items={[
          "Recht auf Auskunft über die zu deiner Person gespeicherten Daten (Art. 15 DSGVO)",
          "Recht auf Berichtigung unrichtiger Daten (Art. 16 DSGVO)",
          "Recht auf Löschung deiner Daten (Art. 17 DSGVO)",
          "Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)",
          "Recht auf Datenübertragbarkeit (Art. 20 DSGVO)",
          "Recht auf Widerspruch gegen die Verarbeitung (Art. 21 DSGVO)",
          "Recht, eine erteilte Einwilligung jederzeit mit Wirkung für die Zukunft zu widerrufen (Art. 7 Abs. 3 DSGVO)",
        ]}
      />
      <LegalP>
        Zur Geltendmachung deiner Rechte genügt eine formlose Mitteilung an die oben
        genannten Kontaktdaten.
      </LegalP>

      <LegalH2>11. Widerspruchsrecht (Art. 21 DSGVO)</LegalH2>
      <LegalP>
        Soweit wir personenbezogene Daten auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO
        (berechtigtes Interesse) verarbeiten, hast du das Recht, jederzeit Widerspruch
        gegen die Verarbeitung einzulegen, soweit dafür Gründe vorliegen, die sich aus
        deiner besonderen Situation ergeben. Wir verarbeiten die personenbezogenen Daten
        dann nicht mehr, es sei denn, wir können zwingende schutzwürdige Gründe für die
        Verarbeitung nachweisen, die deine Interessen, Rechte und Freiheiten überwiegen,
        oder die Verarbeitung dient der Geltendmachung, Ausübung oder Verteidigung von
        Rechtsansprüchen.
      </LegalP>

      <LegalH2>12. Beschwerderecht bei einer Aufsichtsbehörde</LegalH2>
      <LegalP>
        Du hast das Recht, dich bei einer Datenschutz-Aufsichtsbehörde über die
        Verarbeitung deiner personenbezogenen Daten durch uns zu beschweren (Art. 77
        DSGVO). Für uns zuständig ist:
        <br />
        Der Hamburgische Beauftragte für Datenschutz und Informationsfreiheit
        <br />
        Ludwig-Erhard-Straße 22, 7. OG
        <br />
        20459 Hamburg
        <br />
        <a
          href="https://datenschutz-hamburg.de"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#2185D0] underline underline-offset-2"
        >
          datenschutz-hamburg.de
        </a>
      </LegalP>

      <LegalH2>13. Datensicherheit</LegalH2>
      <LegalP>
        Wir setzen technische und organisatorische Sicherheitsmaßnahmen ein, um deine
        Daten gegen zufällige oder vorsätzliche Manipulationen, Verlust, Zerstörung oder
        den Zugriff unberechtigter Personen zu schützen. Unsere Sicherheitsmaßnahmen
        werden entsprechend der technologischen Entwicklung fortlaufend verbessert.
      </LegalP>

      <LegalH2>14. Keine automatisierte Entscheidungsfindung</LegalH2>
      <LegalP>
        Eine automatisierte Entscheidungsfindung einschließlich Profiling im Sinne von
        Art. 22 DSGVO findet nicht statt.
      </LegalP>

      <LegalH2>15. Aktualität und Änderung dieser Datenschutzerklärung</LegalH2>
      <LegalP>
        Diese Datenschutzerklärung hat den Stand Februar 2026. Durch die Weiterentwicklung
        unserer Website und Angebote oder aufgrund geänderter gesetzlicher bzw.
        behördlicher Vorgaben kann es notwendig werden, diese Datenschutzerklärung
        anzupassen. Die jeweils aktuelle Fassung kann jederzeit auf unserer Website
        abgerufen werden.
      </LegalP>
    </LegalPage>
  );
}
